type UpdateFieldWithNullProps<T> = {
  updated?: T | null
  existing?: T
}
export function updateFieldWithNull<T>({ updated, existing }: UpdateFieldWithNullProps<T>): T | undefined {
  if (updated === undefined) return existing
  if (updated === null) return
  return updated
}
